import React from 'react';
import LCSubPageLayout from './LCSubPageLayout';
import LCCommittees from './LCCommittees';

const LCCommitteesPage: React.FC = () => (
  <LCSubPageLayout title="Committees">
    {(detail) => (
      <LCCommittees
        id={detail.id}
        lcAccess={detail.local_chapter_access}
        lcAction={detail.local_chapter_action}
      />
    )}
  </LCSubPageLayout>
);

export default LCCommitteesPage;
